const citationContainers = document.querySelectorAll(".citation");

if (citationContainers.length) {
  for (const citationContainer of citationContainers) {
    const citationStandards = citationContainer.querySelectorAll(
      ".overflow-link"
    );
    const citationOverflow = citationContainer.querySelector(".overflow");
    const citationStandardText = citationContainer.querySelector(
      ".citation-standard"
    );

    for (const citationItem of citationStandards) {
      citationItem.addEventListener("click", function (e) {
        e.stopPropagation();
        e.preventDefault();

        const selectedStandard = e.target.textContent;

        // Change tab active class
        for (citationStandard of citationStandards) {
          citationStandard.classList.remove("active");
          citationStandard.classList.add("inactive");
        }
        this.classList.remove("inactive");
        this.classList.add("active");

        // Change visible tab content
        const targetId = this.getAttribute("data-id");
        const citationsContent = citationContainer.querySelectorAll(
          ".citation-style"
        );
        for (const citationContent of citationsContent) {
          citationContent.classList.remove("active");
        }
        let targetContainer = citationContainer.querySelector(
          `.citation-style[data-id="${targetId}"]`
        );
        targetContainer.classList.toggle("active");

        // Hide the popup.
        citationOverflow.classList.remove("active");
        citationStandardText.textContent = selectedStandard;
      });
    }
  }
}
